var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#528AEA",
    fillRule: "evenodd",
    d: "M16.317 9.65V7.888H9.332V.904H7.57v6.984H.586V9.65H7.57v6.985h1.762V9.65z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusTheme);
export default __webpack_public_path__ + "static/media/plus-theme.49f5895065b1def115d0dda08f23e9d6.svg";
export { ForwardRef as ReactComponent };